import { BreadcrumbsModel } from '../../types/Breadcrumbs/BreadcrumbsModel';

export const OrdersBreadcrumbs = () : BreadcrumbsModel[] => ([
    {
        key: '1',
        value: 'Заказы',
        url: '',
    },
    {
        key: '2',
        value: 'Список заказов',
        url: '',
    },
]);
